import { Component, Input } from "@angular/core";
import { ChartBindingObject } from "@tylertech/charting-module";
import { CustomViewService } from "@tylertech/custom-view";
import { StringHelper } from "@tylertech/shared-module";
import { IChartCriteria } from "@tylertech/tyler-api-types";

@Component({
    selector: "dashboard-chart",
    templateUrl: "./dashboardChart.tmpl.html",
    standalone: false
})
export class DashboardChartComponent
{
    private readonly chartMap = new Map<string, string>();
    private _chartCriteria: IChartCriteria;

    isCustom: boolean;
    customComponent: string;
    customData: ChartBindingObject;

    @Input()
    get chartCriteria(): IChartCriteria { return this._chartCriteria; }

    set chartCriteria(value: IChartCriteria)
    {
        this._chartCriteria = value;

        const selector = this._chartCriteria?.ChartId
            ? StringHelper.toKebabCase(this._chartCriteria.ChartId.replace(".", ""))
            : undefined;
        this.isCustom = this.customViewService.hasView(selector);
        this.customComponent = selector;
        this.customData = {
            chartCriteria: this._chartCriteria,
            chartId: this._chartCriteria.ChartId
        };
    }

    constructor(
        private readonly customViewService: CustomViewService)
    { }
}
